import React, {Component} from 'react';
import {Button, Collapse} from "reactstrap";
import {ClientAdAccountRow} from "./ClientAdAccountRow";
import {Spinner} from "../../Spinner";
import {FaIcon} from "../../FaIcon";
import {UnlinkedAdAccountRow} from "../../agency/UnlinkedAdAccountRow";
import {IgnoredAdAccountRow} from "../../agency/IgnoredAdAccountRow";
import {AddClientAdAccountModal} from "./AddClientAdAccountModal";
import {HELP_DAILY_LIMIT, LinkToArticle} from "../../help_center/LinkToArticle";
import {CHANNEL_INFO_BY_CHANNEL, CHANNEL_TYPE_ECOMMERCE, CHANNEL_TYPE_PROFITABILITY, ChannelsHelper} from "../../channels/channels";
import {ClientStoreRow} from "./ClientStoreRow";
import {ClientProfitabilityRow} from "./ClientProfitabilityRow";
import {AddClientStoreModal} from "./AddClientStoreModal";
import { withTranslation } from 'react-i18next';
import {AccessService} from "../../../utils/AccessService";
import {LocalStorage} from "../../../utils/LocalStorage";
import {AccountsFilterBar} from "../../agency/AccountsFilterBar";
import {InviteClientToManageConnectionsButton} from "./InviteClientToManageConnectionsButton";


// El modo define las columnas y datos que se muestran.
export const VIEW_MODE_CLIENT_ACCOUNTS = 'CLIENT-ACCOUNTS'
export const VIEW_MODE_CLIENT_MONITORING = 'CLIENT-MONITORING'
export const VIEW_MODE_AGENCY_ACCOUNTS = 'AGENCY-ACCOUNTS'

// Las cuentas se agrupan por FAMILIA: las de «Rentabilidad del negocio» (organizaciones de Escalafy) no
// son cuentas publicitarias —sin límite diario, presupuesto, eventos ni campañas— y van en su sección. El
// `channel_type` del backend cubre a un canal de la familia que este bundle todavía no conozca.
export function isProfitabilityAccount(clientAdAccount) {
    return !!clientAdAccount && (ChannelsHelper.channelIsProfitability(clientAdAccount.channel)
        || clientAdAccount.channel_type === CHANNEL_TYPE_PROFITABILITY);
}

class ClientAdAccountAndStoresListClass extends Component {

    constructor(props) {
        super(props);

        this.state = {
            linkedAdAccountsIsOpen: true,
            linkedStoresIsOpen: true,
            unlinkedAdAccountsIsOpen: false,
            ignoredAdAccountsIsOpen: false,
            isSaving: this.props.isSaving,
            hasAgentModule: false,
        };

        this.toggleLinkedAdAccounts = this.toggleLinkedAdAccounts.bind(this);
        this.toggleUnLinkedAdAccounts = this.toggleUnLinkedAdAccounts.bind(this);
        this.toggleIgnoredAdAccounts = this.toggleIgnoredAdAccounts.bind(this);
    }

    componentDidMount() {
        const userId = LocalStorage.fetchUserId();
        if (userId) {
            AccessService.GetUserModules(userId, (data) => {
                const modules = data.modules || [];
                this.setState({hasAgentModule: modules.includes(AccessService.MODULE_AGENT)});
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isSaving !== this.props.isSaving) {
            this.setState({isSaving: this.props.isSaving});
        }
    }

    showingListForAPredefinedClient() {
        return typeof this.props.clientId !== 'undefined' && this.props.clientId > 0;
    }

    showClientColumn() {
        return !this.showingListForAPredefinedClient();
    }

    renderClientColumn() {
        const { t } = this.props;
        if (this.showClientColumn()) {
            return (<th>{t('client_ad_account_stores_list.client')}</th>);
        } else {
            return null;
        }
    }

    renderDailyBudgetColumn() {
        const { t } = this.props;
        if (this.isMonitoringViewMode() || this.isAgencyAccountsViewMode()) {
            return (<th>{t('client_ad_account_stores_list.daily_budget_platform')}</th>);
        } else {
            return null;
        }
    }

    dailyLimitColumnHeader() {
        const { t } = this.props;
        if (this.isConnectionViewMode())
            return null;

        return (<th>{t('client_ad_account_stores_list.daily_limit')}</th>);
    }

    monitoringColumnData() {
        const { t } = this.props;
        if (!this.isConnectionViewMode())
            return;

        return (<th>{t('client_ad_account_stores_list.monitoring')}</th>);
    }

    selectedEventsColumnData() {
        const { t } = this.props;
        if (!this.isConnectionViewMode())
            return;

        return (<th>
            <span className="header-with-tooltip">
                {t('client_ad_account_stores_list.selected_events')}
                <FaIcon iconName="info-circle" className="header-info-icon"/>
                <span className="header-tooltip">
                    {t('client_ad_account_stores_list.selected_events_tooltip')}
                </span>
            </span>
        </th>);
    }

    integrationsColumnData() {
        const { t } = this.props;
        if (!this.isConnectionViewMode() && !this.isAgencyAccountsViewMode())
            return;

        return (<th>{t('client_ad_account_stores_list.integrations')}</th>);
    }

    toggleLinkedAdAccounts() {
        const isOpen = this.state.linkedAdAccountsIsOpen;
        this.setState({
            linkedAdAccountsIsOpen: !isOpen
        })
    }

    toggleLinkedStores() {
        const isOpen = this.state.linkedStoresIsOpen;
        this.setState({
            linkedStoresIsOpen: !isOpen
        })
    }

    toggleUnLinkedAdAccounts() {
        const isOpen = this.state.unlinkedAdAccountsIsOpen;
        this.setState({
            unlinkedAdAccountsIsOpen: !isOpen
        })
    }

    toggleIgnoredAdAccounts() {
        const isOpen = this.state.ignoredAdAccountsIsOpen;
        this.setState({
            ignoredAdAccountsIsOpen: !isOpen
        })
    }

    getSectionCount(filteredLength, unfilteredKey) {
        if (this.isAgencyAccountsViewMode() && this.props.hasActiveFilters && this.props.unfilteredCounts) {
            return `${filteredLength}/${this.props.unfilteredCounts[unfilteredKey]}`;
        }
        return `${filteredLength}`;
    }

    allFilteredListsEmpty() {
        const caa = this.props.clientAdAccounts;
        const cs = this.props.clientStores;
        const ua = this.props.unlinkedAdAccounts;
        const ia = this.props.ignoredAdAccounts;
        const statuses = this.props.selectedStatuses;

        const linkedEmpty = !statuses || !statuses.has('linked')
            || ((caa !== null && caa.length === 0) && (cs !== null && cs.length === 0));
        const unlinkedEmpty = !statuses || !statuses.has('unlinked')
            || (ua === undefined || ua === null || ua.length === 0);
        const ignoredEmpty = !statuses || !statuses.has('ignored')
            || (ia === undefined || ia === null || ia.length === 0);

        return linkedEmpty && unlinkedEmpty && ignoredEmpty;
    }

    renderFilterEmptyState() {
        const { t } = this.props;
        return (
            <div className="accounts-filter-bar__empty-state">
                <FaIcon iconName="search" />
                <p><strong>{t('agency_accounts_filter.no_results_title')}</strong></p>
                <p>{t('agency_accounts_filter.no_results_description')}</p>
                <button className="accounts-filter-bar__clear" onClick={this.props.onClearFilters}>
                    {t('agency_accounts_filter.clear_filters')}
                </button>
            </div>
        );
    }

    renderAccountsFilterBar() {
        if (!this.isAgencyAccountsViewMode()) return null;
        if (!this.props.unfilteredAccounts) return null;

        return (
            <AccountsFilterBar
                accounts={this.props.unfilteredAccounts}
                selectedPlatforms={this.props.selectedPlatforms}
                selectedStatuses={this.props.selectedStatuses}
                searchQuery={this.props.searchQuery}
                onPlatformToggle={this.props.onPlatformToggle}
                onSearchChange={this.props.onSearchChange}
                onStatusToggle={this.props.onStatusToggle}
                onClearAll={this.props.onClearFilters}
            />
        );
    }

    render() {
        const { t } = this.props;
        const linkedStoreTitle = this.props.clientStores !== null ? (this.showingListForAPredefinedClient() ? t('client_ad_account_stores_list.linked_stores') : `${t('client_ad_account_stores_list.linked_stores')} ${t('client_ad_account_stores_list.to_clients')} (${this.getSectionCount(this.props.clientStores.length, 'clientStores')})`) : "";

        let linkedAdAccountTitle = t('client_ad_account_stores_list.linked_accounts');
        if(this.isMonitoringViewMode() || this.isAgencyAccountsViewMode()) {
            linkedAdAccountTitle = this.props.clientAdAccounts !== null ? (this.showingListForAPredefinedClient() ? <>{t('client_ad_account_stores_list.daily_limits')} <LinkToArticle  article={HELP_DAILY_LIMIT}/></> : `${t('client_ad_account_stores_list.linked_accounts')} ${t('client_ad_account_stores_list.to_clients')} (${this.getSectionCount(this.linkedAdAccounts().length, 'clientAdAccounts')})`) : "";
        }


        const unlinkedAdAccountTitle = this.props.unlinkedAdAccounts !== undefined && this.props.unlinkedAdAccounts !== null ? `${t('client_ad_account_stores_list.unlinked_accounts')} (${this.getSectionCount(this.props.unlinkedAdAccounts.length, 'unlinkedAdAccounts')})` : "";
        const ignoredAdAccountTitle = this.props.ignoredAdAccounts !== undefined && this.props.ignoredAdAccounts !== null ? `${t('client_ad_account_stores_list.ignored_accounts')} (${this.getSectionCount(this.props.ignoredAdAccounts.length, 'ignoredAdAccounts')})` : "";

        if (this.isAgencyAccountsViewMode() && this.props.hasActiveFilters && this.allFilteredListsEmpty()) {
            return (
                <div className="section-body-item -widest">
                    {this.renderAccountsFilterBar()}
                    {this.renderFilterEmptyState()}
                </div>
            );
        }

        return (
            <div className="section-body-item -widest">
                {this.renderAccountsFilterBar()}
                {this.showLinkedAccountsSection(linkedAdAccountTitle, !this.showingListForAPredefinedClient())}
                {this.showLinkedStoresSection(linkedStoreTitle, !this.showingListForAPredefinedClient())}
                {this.showProfitabilitySection()}
                {this.showUnlinkedAdAccountsSection(unlinkedAdAccountTitle)}
                {this.showIgnoredAccountsSection(ignoredAdAccountTitle)}
            </div>
        );
    }

    renderLinkDropDownIcon(allowToggle) {
        if(!allowToggle)
            return;

        return <div style={{padding:"18px 0px 15px 10px"}}>{this.dropDownIcon()}</div>
    }

    renderLinkAccountButton() {
        const { t } = this.props;
        return <div>
            <Button className="-alt" onClick={(e) => {e.stopPropagation();this.addClientAdAccountModal.toggle()}}>{this.showingListForAPredefinedClient() && this.isMonitoringViewMode() ? t('client_ad_account_stores_list.add_daily_limit') : t('client_ad_account_stores_list.link_account')}</Button>
            <AddClientAdAccountModal ref={instance => {this.addClientAdAccountModal = instance;}}
                                     afterSuccessfulSubmit={this.props.afterSuccessfulClientAdAccountSubmit}
                                     clientId={this.props.clientId} clientName={this.props.clientName}
                                     hasAgentModule={this.state.hasAgentModule}
            />
        </div>;
    }

    renderInviteToManageConnectionsButton() {
        // Solo en la ficha de un cliente concreto: invita al cliente a autogestionar sus conexiones.
        if (!this.showingListForAPredefinedClient() || !this.props.clientId)
            return null;
        return <InviteClientToManageConnectionsButton clientId={this.props.clientId}/>;
    }

    renderLinkStoreButton() {
        const { t } = this.props;
        return <div>
            <Button className="-alt" onClick={(e) => {e.stopPropagation();this.addClientStoreModal.toggle()}}>{this.showingListForAPredefinedClient() ? t('client_ad_account_stores_list.add_store') : t('client_ad_account_stores_list.link_store')}</Button>
            <AddClientStoreModal ref={instance => {this.addClientStoreModal = instance;}}
                                     afterSuccessfulSubmit={this.props.afterSuccessfulClientStoreSubmit}
                                     clientId={this.props.clientId} clientName={this.props.clientName}
            />
        </div>;
    }

    showLinkedAccountsSection(linkedAdAccountTitle, allowToggle) {
        if (this.isAgencyAccountsViewMode() && this.props.selectedStatuses && !this.props.selectedStatuses.has('linked'))
            return null;

        const style = allowToggle ? {cursor: "pointer"} : null;

        return <div className="box col-12 mb-5">
            <header onClick={() => {if(allowToggle) this.toggleLinkedAdAccounts();}} className="box-header" style={style}>
                <h2 className="box-title">{linkedAdAccountTitle}</h2>
                <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                    {this.renderInviteToManageConnectionsButton()}
                    {this.renderLinkAccountButton()}
                    {this.renderLinkDropDownIcon(allowToggle)}
                </div>
            </header>
                <Collapse isOpen={this.state.linkedAdAccountsIsOpen}>
                {this.getTableDataForLinkedAccounts()}
            </Collapse>
        </div>;
    }

    showLinkedStoresSection(linkedStoreTitle, allowToggle) {
        if(!this.isConnectionViewMode() && !this.isAgencyAccountsViewMode())
            return;

        if (this.isAgencyAccountsViewMode() && this.props.selectedStatuses && !this.props.selectedStatuses.has('linked'))
            return null;

        // Solo mostramos esta sección si la agencia tiene el canal en la suscripción
        if(!this.agencyHasEcommerceChannel())
            return;

        const style = allowToggle ? {cursor: "pointer"} : null;

        return <div className="box col-12 mb-5">
            <header onClick={() => {if(allowToggle) this.toggleLinkedStores();}} className="box-header" style={style}>
                <h2 className="box-title">{linkedStoreTitle}</h2>
                <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                    {this.renderLinkStoreButton()}
                    {this.renderLinkDropDownIcon(allowToggle)}
                </div>
            </header>
            <Collapse isOpen={this.state.linkedStoresIsOpen}>
                {this.getTableDataForLinkedStores()}
            </Collapse>
        </div>;
    }

    linkedAdAccounts() {
        return (this.props.clientAdAccounts || []).filter((caa) => !isProfitabilityAccount(caa));
    }

    profitabilityAccounts() {
        return (this.props.clientAdAccounts || []).filter(isProfitabilityAccount);
    }

    // «Rentabilidad del negocio»: sólo donde se listan conexiones (no en el monitoreo de límites), y sólo si
    // hay alguna vinculada. Se vinculan desde «Vincular cuenta», como el resto.
    showProfitabilitySection() {
        const { t } = this.props;
        if (!this.isConnectionViewMode() && !this.isAgencyAccountsViewMode())
            return null;
        if (this.isAgencyAccountsViewMode() && this.props.selectedStatuses && !this.props.selectedStatuses.has('linked'))
            return null;

        const accounts = this.profitabilityAccounts();
        if (accounts.length === 0)
            return null;

        return <div className="box col-12 mb-5 client-profitability-section" data-testid="client-profitability-section">
            <header className="box-header">
                <h2 className="box-title">{t('clients.profitability_section')}</h2>
            </header>
            {/* Scroll propio: a 390 px la tabla es más ancha que la caja y la acción quedaba afuera. */}
            <div className="table-box" style={{overflowX: 'auto'}}>
                <table className="table table-striped">
                    <thead>
                    <tr>
                        <th>{t('client_ad_account_stores_list.account')}</th>
                        {this.renderClientColumn()}
                        <th>{t('client_ad_account_stores_list.accessible')}</th>
                        <th>{t('client_ad_account_stores_list.actions')}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {accounts.map((clientAdAccount) =>
                        <ClientProfitabilityRow key={clientAdAccount.id}
                                                clientAdAccount={clientAdAccount}
                                                showClientColumn={this.showClientColumn()}
                                                onRemove={this.props.doClientAdAccountRemove}
                                                isSaving={this.state.isSaving}
                        />
                    )}
                    </tbody>
                </table>
            </div>
        </div>;
    }

    showIgnoredAccountsSection(ignoredAdAccountTitle) {
        if(this.showingListForAPredefinedClient())
            return;

        if (this.props.selectedStatuses && !this.props.selectedStatuses.has('ignored'))
            return null;

        return <div className="box col-12">
            <header onClick={this.toggleIgnoredAdAccounts} className="box-header ignored-ad-accounts"
                    style={{cursor: "pointer"}}>
                <h2 className="box-title">{ignoredAdAccountTitle}</h2>
                {this.dropDownIcon()}
            </header>
            <Collapse isOpen={this.state.ignoredAdAccountsIsOpen}>
                {this.getIgnoredAccountsTableData()}
            </Collapse>
        </div>;
    }

    showUnlinkedAdAccountsSection(unlinkedAdAccountTitle) {
        if(this.showingListForAPredefinedClient())
            return;

        if (this.props.selectedStatuses && !this.props.selectedStatuses.has('unlinked'))
            return null;

        return <div className="box col-12 mb-4">
            <header onClick={this.toggleUnLinkedAdAccounts} className="box-header unlinked-ad-accounts"
                    style={{cursor: "pointer"}}>
                <h2 className="box-title">{unlinkedAdAccountTitle}</h2>
                {this.dropDownIcon()}
            </header>
            <Collapse isOpen={this.state.unlinkedAdAccountsIsOpen}>
                {this.getUnlinkedAdAccountsTableData()}
            </Collapse>
        </div>;
    }

    dropDownIcon() {
        return <FaIcon className="dropdown-arrow" iconName="chevron-down" />
    }

    getTableDataForLinkedAccounts() {
        const { t } = this.props;
        if (this.props.clientAdAccounts !== null) {
            const result = [<div className="table-box">
                <table className="table table-striped">
                    <thead>
                    <tr>
                        <th>{t('client_ad_account_stores_list.account')}</th>
                        <th>{t('client_ad_account_stores_list.currency')}</th>
                        {this.renderClientColumn()}
                        {this.renderDailyBudgetColumn()}
                        {this.dailyLimitColumnHeader()}
                        {this.monitoringColumnData()}
                        {this.selectedEventsColumnData()}
                        {this.integrationsColumnData()}
                        <th>{t('client_ad_account_stores_list.accessible')}</th>
                        <th>{t('client_ad_account_stores_list.actions')}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.clientAdAccountRows()}
                    </tbody>
                </table>
            </div>];

            if (!this.showingListForAPredefinedClient()) {
                result.push(<div className="field-footnote mt-2">{t('client_ad_account_stores_list.only_accessible_accounts')}</div>);
            }
            return result;
        } else {
            return (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            )
        }
    }

    isMonitoringViewMode() {
        return this.props.mode === undefined || this.props.mode === VIEW_MODE_CLIENT_MONITORING;
    }

    isAgencyAccountsViewMode() {
        return this.props.mode === VIEW_MODE_AGENCY_ACCOUNTS;
    }

    isConnectionViewMode() {
        return this.props.mode === VIEW_MODE_CLIENT_ACCOUNTS;
    }

    getTableDataForLinkedStores() {
        const { t } = this.props;
        if (this.props.clientStores !== null) {
            if (this.props.clientStores.length === 0) {
                return <div style={{textAlign: 'center', padding: '2.5em 1em'}}>
                    <p style={{color: '#B6B6B7', fontSize: '0.9em', margin: 0}}>
                        {t('client_ad_account_stores_list.no_stores_yet')}
                    </p>
                </div>;
            }

            const result = [<div className="table-box">
                <table className="table table-striped">
                    <thead>
                    <tr>
                        <th>{t('client_ad_account_stores_list.store')}</th>
                        <th>{t('client_ad_account_stores_list.currency')}</th>
                        {this.renderClientColumn()}
                        <th>{t('client_ad_account_stores_list.url')}</th>
                        <th>{t('client_ad_account_stores_list.looker_studio')}</th>
                        <th>{t('client_ad_account_stores_list.data_node')}</th>
                        <th>{t('client_ad_account_stores_list.mcp')}</th>
                        <th>{t('client_ad_account_stores_list.accessible')}</th>
                        <th>{t('client_ad_account_stores_list.actions')}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.clientStoreRows()}
                    </tbody>
                </table>
            </div>];

            if (!this.showingListForAPredefinedClient()) {
                result.push(<div className="field-footnote mt-2">{t('client_ad_account_stores_list.only_accessible_stores')}</div>);
            }
            return result;
        } else {
            return (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            )
        }
    }

    getUnlinkedAdAccountsTableData() {
        const { t } = this.props;
        if (this.props.unlinkedAdAccounts !== null) {
            return [<div className="table-box col-6">
                <table className="table table-striped">
                    <thead>
                    <tr>
                        <th>{t('client_ad_account_stores_list.account')}</th>
                        <th>{t('client_ad_account_stores_list.actions')}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.unlinkedAdAccountsRows()}
                    </tbody>
                </table>
            </div>];
        } else {
            return (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            )
        }
    }

    getIgnoredAccountsTableData() {
        const { t } = this.props;
        if (this.props.ignoredAdAccounts !== null) {
            return [<div className="table-box col-6">
                <table className="table table-striped">
                    <thead>
                    <tr>
                        <th>{t('client_ad_account_stores_list.account')}</th>
                        <th>{t('client_ad_account_stores_list.activity')}</th>
                        <th>{t('client_ad_account_stores_list.actions')}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.ignoredAdAccountsRows()}
                    </tbody>
                </table>
            </div>];
        } else {
            return (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            )
        }
    }

    clientStoreRows() {
        return this.props.clientStores.map((clientStore) =>
            <ClientStoreRow key={clientStore.id} 
                            clientId={this.props.clientId}
                            clientName={this.props.clientName}
                            clientStore={clientStore}
                            onRemove={this.props.doClientStoreRemove}
                            onEdit={this.props.doClientStoreEdit}
                            isSaving={this.state.isSaving}
                            showClientColumn={this.showClientColumn()}
                            accessManagementEnabled={this.props.accessManagementEnabled}
            />
        );
    }

    clientAdAccountRows() {
        return this.linkedAdAccounts().filter((caa) => (!this.showingListForAPredefinedClient() || this.props.mode === VIEW_MODE_CLIENT_ACCOUNTS || CHANNEL_INFO_BY_CHANNEL[caa.channel]?.dailyLimitEnabled === true)).map((clientAdAccount) =>
            <ClientAdAccountRow key={clientAdAccount.id}
                                mode={this.props.mode}
                                clientId={this.props.clientId}
                                clientName={this.props.clientName}
                                clientAdAccount={clientAdAccount}
                                onRemove={this.props.doClientAdAccountRemove}
                                onEdit={this.props.doClientAdAccountEdit}
                                isSaving={this.state.isSaving}
                                showClientColumn={this.showClientColumn()}
                                accessManagementEnabled={this.props.accessManagementEnabled}
                                hasAgentModule={this.state.hasAgentModule}
            />
        );
    }

    getAdAccountToIgnore() {
        // Check if the URL contains the parameter that indicates modal display
        const params = new URLSearchParams(this.props.location.search);
        const shouldShowModalIgnore = params.get('ignore') !== null && params.get('ignore').includes("||");
        const ignoreChannel = shouldShowModalIgnore? params.get('ignore').split("||")[0] : null;
        const adAccountId = shouldShowModalIgnore? parseInt(params.get('ignore').split("||")[1], 10) : null;


        return shouldShowModalIgnore ? {"channel": ignoreChannel, "accountId": adAccountId} : null;
    }

    shouldIgnoreAccount(accountToIgnore, accountToCheck) {
        if(accountToIgnore === null)
            return false;

        return (accountToIgnore["channel"] === accountToCheck.channel && accountToIgnore["accountId"] === accountToCheck.account_id);
    }

    unlinkedAdAccountsRows() {
        const accountToIgnore = this.getAdAccountToIgnore();

        return this.props.unlinkedAdAccounts.map((adAccount) =>
            <UnlinkedAdAccountRow key={adAccount.id}
                                  adAccount={adAccount}
                                  onSnoozeForever={this.props.doSnoozeForever}
                                  onAssignToClient={this.props.afterSuccessfulClientAdAccountSubmit}
                                  isSaving={this.state.isSaving}
                                  loadIgnoreModal={this.shouldIgnoreAccount(accountToIgnore, adAccount)}
                                  hasAgentModule={this.state.hasAgentModule}
            />
        );
    }

    ignoredAdAccountsRows() {
        return this.props.ignoredAdAccounts.map((adAccountData) =>
            <IgnoredAdAccountRow key={adAccountData.ad_account.id}
                                  adAccount={adAccountData.ad_account}
                                  snoozeInfo={adAccountData.alert_snooze}
                                  onSnoozeForever={this.props.doSnoozeForever}
                                  onAssignToClient={this.props.afterSuccessfulClientAdAccountSubmit}
            />
        );
    }

    agencyHasEcommerceChannel() {
        if (!this.props.channels) 
            return false;

        return this.props.channels.some(channel => CHANNEL_INFO_BY_CHANNEL[channel] && CHANNEL_INFO_BY_CHANNEL[channel].channelType === CHANNEL_TYPE_ECOMMERCE);
    }
}

export const ClientAdAccountAndStoresList = withTranslation()(ClientAdAccountAndStoresListClass);
export default ClientAdAccountAndStoresList;
